import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Document, Page, Text, View, PDFViewer, StyleSheet, Image } from "@react-pdf/renderer";
import axios from "axios";
import config from "../config";

const styles = StyleSheet.create({
  page: { padding: 15, fontSize: 10, fontFamily: "Helvetica" },
  headerContainer: { textAlign: "center", marginBottom: 5 },
  title: { fontSize: 12, fontWeight: "bold", marginBottom: 2 },
  separator: { borderBottom: "1 solid black", marginVertical: 5 },
  section: { marginBottom: 4 },
  label: { fontWeight: "bold" },
  note: { marginTop: 10, fontSize: 8, borderTop: "1 solid black", paddingTop: 5, textAlign: "center" },
});

const ChallanPDF = ({ challanData }) => (

  <Document>

    {["MBOSE COPY", "CENTRE COPY", "BANK COPY"].map((copyType, index) => (
      <Page key={index} size="A4" style={styles.page}>
        <View style={{ position: "absolute", top: 10, right: 15 }}>
          <Text>({copyType})</Text>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: -5, marginBottom: 10 }}>
          {/* Logo Section */}
          <Image
            src="../assets/images/MBOSE.png"
            style={{ width: 50, height: 50, marginRight: 10 }}
          />

          {/* Header Text Section */}
          <View style={{ flex: 1, textAlign: "center", marginLeft: -60 }}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>
              Meghalaya Board Of School Education (SSLC)
            </Text>
            <Text style={{ marginTop: 4, fontSize: 10 }}>
              RTGS / NEFT Remittance Advice for{" "}
              <Text style={{ fontWeight: "bold" }}>
                SSLC Supplementary Exam- 2026
              </Text>
            </Text>
            <Text style={{ marginTop: 4, fontSize: 9 }}>
              (To be submitted in original along with the consolidated statement)
            </Text>
          </View>
        </View>

        <View style={styles.separator} />

        <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: '-5px' }}>
          <Text style={styles.section}>
            <Text style={styles.label}>Challan No: </Text> {challanData?.CHALLAN_NO || "N/A"}
          </Text>
          <Text style={styles.section}>
            <Text style={styles.label}>Challan Generated On: </Text> {challanData?.CHALLAN_DATE_TIME || "N/A"}
          </Text>
        </View>
        <View style={styles.separator} />
        <View>
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>
            1. BENEFICIARY DETAILS:
          </Text>

          {/* A/C Name */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>a. A/C Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.AC_NAME || "N/A"}</Text>

          </View>

          {/* Bank Name */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>b. Bank Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.BANK_NAME || "N/A"}</Text>
          </View>

          {/* Branch Name */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>c. Branch Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.BRANCH_NAME || "N/A"}</Text>
          </View>

          {/* IFSC Code */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>d. IFSC Code</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.IFSC || "N/A"}</Text>
          </View>

          {/* A/C Type */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>e. A/C Type</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.AC_TYPE || "N/A"}</Text>
          </View>

          {/* Account Number */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>f. Account Number</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.AC_NUMBER || "N/A"}</Text>
          </View>

          {/* Email ID */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>g. Email ID</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.EMAIL_ID || "N/A"}</Text>
          </View>
        </View>

        <View>
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5, marginTop: 5 }}>
            2. DEPOSITOR DETAILS:
          </Text>

          {/* Center Code */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>a. Center Code</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.CENTER_CODE || "N/A"}</Text>
          </View>

          {/* Center Name */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>b. Center Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.CENTER_NAME || "N/A"}</Text>
          </View>

          {/* Purpose of Deposit */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>c. Purpose of Deposit</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>EXAMINATION FEES</Text>
          </View>

          {/* No. of Students */}
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>d. No. of Students</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.NO_OF_STUDENT || "N/A"}</Text>
          </View>
        </View>

        <View>
          <View style={{ flexDirection: "row" }}>
            <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5, marginTop: 5, width: 130 }}>
              3. FEES DETAILS:
            </Text>
            <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5, marginTop: 5 }}>Amount(in RS)</Text>
          </View>
          <View style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}>
            <Text style={{ fontSize: 10, width: 120 }}>a. Amount (in figure) Rs</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>{challanData?.EXAM_FEES || "N/A"}</Text>
          </View>
        </View>

        <View>

          {/* Section Title */}
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5, marginTop: 5 }}>
            4. REMITTANCE DETAILS:
          </Text>

          {/* Amount (in figure) Rs. */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>
              a. Amount (in figure) Rs.
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* Charges */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>b. Charges ( Rupees )</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>


          {/* Bank Name */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>c. Bank Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* Branch Name */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>d. Branch Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* A/C Type */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>e. A/C Type</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* A/C No */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>f. A/C No</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* IFSC Code */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>g. IFSC CODE</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* UTR No. */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>h. UTR No.</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

          {/* Date of Remittance */}
          <View style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}>
            <Text style={{ fontSize: 10, width: 150 }}>i. Date of Remittance</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}></Text>
          </View>

        </View>
        <Text style={styles.note}>I hereby declare that the particulars mentioned above are correct and true. If the same is found to be false/misleading, I shall abide by the decision of MBOSE.
        </Text>
        <View style={{ marginTop: 10, paddingTop: 5 }}>
          {/* NOTE Section */}
          <View style={{ textAlign: "right", marginTop: 100 }}>
            <Text style={{ fontSize: 8, fontWeight: "bold", marginRight: 30 }}>
              Signature of the Head of the Institution
            </Text>
            <Text style={{ fontSize: 8, marginTop: 2, marginRight: 85 }}>(with Seal)</Text>
            <View style={styles.separator} />
          </View>
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>
            NOTE:
          </Text>

          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            1. The institutions are advised to fill up the RTGS/NEFT form as per their
            banker's format, with the details printed in the advice.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            2. After submission of fees through RTGS/NEFT, please send challan & UTR
            acknowledgement slip scan copy on above-mentioned e-mail.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            3. The institutions are advised to carefully fill point no 4(b) to 4(i)
            only after remittance has been made to MBOSE.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            4. Carefully note the UTR No. for filling up the advice.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            5. Attach a copy of the RTGS/NEFT counter foil/application duly signed by
            the banker along with this advice.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            6. Council copy of the challan will be deposited in the MBOSE as per the
            direction given in the advertisement.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            7. In case of any difficulties, you may contact the above-mentioned Contact
            number.
          </Text>

        </View>

      </Page>
    ))}
  </Document>
);

const GeneratePDF = () => {
  const { challanNo } = useParams();
  const [challanData, setChallanData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert("Token is missing! Please log in again.");
      setLoading(false);
      return;
    }

    axios
      .post(
        `${config.API_BASE_URL}/Auth/GetPdfChallanInfo`,
        { challaN_NO: challanNo },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      )
      .then((response) => {
        if (response.data.status !== 200 || !Array.isArray(response.data.data.challan_info)) {
          alert("Error fetching challan data!");
          setChallanData(null);
          setLoading(false);
          return;
        }
        setChallanData(response.data.data.challan_info[0]);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching challan data:", error);
        setLoading(false);
      });
  }, [challanNo]);

  useEffect(() => {
    if (challanData) {
      console.log("Challan Data:", challanData);
    }
  }, [challanData]);

  // const handleDownload = async () => {
  //   if (!challanData) {
  //     alert("No challan data available!");
  //     return;
  //   }
  //   const blob = await pdf(<ChallanPDF challanData={challanData} />).toBlob();
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = `Challan_${challanData.CHALLAN_NO}.pdf`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  // const handlePrint = async () => {
  //   if (!challanData) {
  //     alert("No challan data available!");
  //     return;
  //   }
  //   const blob = await pdf(<ChallanPDF challanData={challanData} />).toBlob();
  //   const pdfUrl = URL.createObjectURL(blob);
  //   const printWindow = window.open(pdfUrl, "_blank");
  //   printWindow.onload = () => printWindow.print();
  // };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <PDFViewer width="100%" height="600px">
            <ChallanPDF challanData={challanData} />
          </PDFViewer>
          <br />
          {/* <button onClick={handleDownload} style={{ margin: "10px", padding: "8px 15px" }}>Download PDF</button>
          <button onClick={handlePrint} style={{ margin: "10px", padding: "8px 15px" }}>Print PDF</button> */}
        </>
      )}
    </div>
  );
};

export default GeneratePDF;
